import React from 'react'
import { MDBContainer, MDBRow, MDBCol,
    MDBView, MDBMask
} from "mdbreact";
import { HashLink as Link } from 'react-router-hash-link'
import Moment from 'react-moment';
import ProgressiveImage from 'react-progressive-image';

// limit to 3 entries
const LatestBlogs = ({ latestBlogs }) => {

    const blogs = latestBlogs.map((blog)=>
        <>
        <MDBCol className="my-4 my-lg-0 my-md-0" key={blog.id} md="4" lg="4">
            <Link smooth className="black-text" to={`/blog/${blog.id}#blog`}>
                <MDBView zoom hover>
                    <div className="z-depth-2">
                        <ProgressiveImage src={blog.preview.url} placeholder={blog.preview.formats.thumbnail.url}>
                            {(src, loading) => <img 
                            className="w-100"
                            style={{ filter: loading && "blur(10px)" }}
                            src={src} 
                            alt=""/>}
                        </ProgressiveImage>
                    </div>
                    <MDBMask style={{ cursor: 'pointer' }} overlay="black-strong" className="flex-center rounded">
                        <strong className="white-text text-capitalize h6-responsive">
                            read blog
                        </strong>
                    </MDBMask>
                </MDBView>
                <h4 style={{ letterSpacing: '0.1rem' }} className="h4-responsive py-2 black-text my-2 font-weight-bold">
                    {blog.title}
                </h4>
                <h5 className="h5-responsive mb-4">
                    {blog.description}
                </h5>
                <div className="d-flex justify-content-between">
                    <Link smooth to={`/blog/${blog.id}#blog`} className="h6-responsive link-underline">
                        Read More
                    </Link>
                    <h6 className="h6-responsive">
                        <Moment fromNow>
                            {blog.createdAt}
                        </Moment>
                    </h6>
                </div>
            </Link>
        </MDBCol>  
        </>
    )

    return (
        <section id="featured-blogs" className="grey lighten-4 py-5 my-5">
            <MDBContainer className="my-5 py-5">
                <h1 className="display-4 menu-mobile-style mb-5 font-weight-bold">
                    Fresh from the Blogs
                </h1>
                <MDBRow>
                    {blogs}
                </MDBRow>
            </MDBContainer>   
        </section>
    )
}

export default LatestBlogs
